export default "__VITE_ASSET__CCEfbTYz__"